/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiOperation } from '../../asyncapi/models/AaiOperation';
import { AbstractCommand } from '../AbstractCommand';
import { JsonCompat } from '../../compat/JsonCompat';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { Node } from '../../core/models/Node';
import { AaiMessage } from '../../asyncapi/models/AaiMessage';

/**
 * A command used to delete an Example for an AsyncAPI 2.0 Message.
 * @author laurent.broudoux@gmail.com
 * @param {AaiOperation} operationNode
 * @param {*} exampleValue
 * @class
 * @extends AbstractCommand
 */
export class DeleteMessageExampleCommand_Aai20 extends AbstractCommand {
    public _parentPath : NodePath;

    public _exampleValue : any;

    public _exampleRemoved : boolean;

    public constructor(operationNode? : any, exampleValue? : any) {
        if(((operationNode != null && operationNode instanceof <any>AaiOperation) || operationNode === null) && ((exampleValue != null) || exampleValue === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._exampleValue===undefined) this._exampleValue = null;
            if(this._exampleRemoved===undefined) this._exampleRemoved = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._exampleValue===undefined) this._exampleValue = null;
            if(this._exampleRemoved===undefined) this._exampleRemoved = false;
            (() => {
                this._parentPath = Library.createNodePath(operationNode);
                this._exampleValue = exampleValue;
            })();
        } else if(operationNode === undefined && exampleValue === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._exampleValue===undefined) this._exampleValue = null;
            if(this._exampleRemoved===undefined) this._exampleRemoved = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._exampleValue===undefined) this._exampleValue = null;
            if(this._exampleRemoved===undefined) this._exampleRemoved = false;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteMessageExampleCommand_Aai20] Executing.");
        let operation : AaiOperation = <AaiOperation>this._parentPath.resolve(document);
        this._exampleRemoved = false;
        if(this.isNullOrUndefined(operation) || this.isNullOrUndefined(operation.message)) {
            return;
        }
        let examples : Array<any> = operation.message.examples;
        if(examples == null) {
            return;
        }
        if(JsonCompat.isString(this._exampleValue)) {
            this._exampleValue = JsonCompat.parseJSON(JsonCompat.toString(this._exampleValue));
        }
        let newExample : any = <any>({});
        {
            let array147 = JsonCompat.keys(this._exampleValue);
            for(let index146=0; index146 < array147.length; index146++) {
                let key = array147[index146];
                {
                    /* put */(newExample[key] = JsonCompat.getProperty(this._exampleValue, key));
                }
            }
        }
        let elementIndex : number = -1;
        for(let i : number = 0; ((lhs, rhs) => lhs && rhs)(elementIndex === -1, i < /* size */(<number>operation.message.examples.length)); i++) {{
            let example : any = /* get */operation.message.examples[i];
            if(/* size */Object.keys(example).length === /* size */Object.keys(newExample).length) {
                elementIndex = i;
                {
                    let array149 = /* entrySet */(o => { let s = []; for (let e in o) s.push({ k: e, v: o[e], getKey: function() { return this.k }, getValue: function() { return this.v } }); return s; })(example);
                    for(let index148=0; index148 < array149.length; index148++) {
                        let entry = array149[index148];
                        {
                            if(!/* containsKey */newExample.hasOwnProperty(entry.getKey()) || !/* equals */(<any>((o1: any, o2: any) => { if(o1 && o1.equals) { return o1.equals(o2); } else { return o1 === o2; } })(JsonCompat.stringify(/* get */((m,k) => m[k]===undefined?null:m[k])(newExample, entry.getKey())),JsonCompat.stringify(entry.getValue())))) {
                                elementIndex = -1;
                                break;
                            }
                        }
                    }
                }
            }
        };}
        if(elementIndex !== -1) {
            /* remove */operation.message.examples.splice(elementIndex, 1)[0];
        }
        this._exampleRemoved = true;
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteMessageExampleCommand_Aai20] Reverting.");
        let operation : AaiOperation = <AaiOperation>this._parentPath.resolve(document);
        if(!this._exampleRemoved || this.isNullOrUndefined(operation) || this.isNullOrUndefined(operation.message)) {
            return;
        }
        let newExample : any = <any>({});
        {
            let array151 = JsonCompat.keys(this._exampleValue);
            for(let index150=0; index150 < array151.length; index150++) {
                let key = array151[index150];
                {
                    /* put */(newExample[key] = JsonCompat.getProperty(this._exampleValue, key));
                }
            }
        }
        /* add */(operation.message.examples.push(newExample)>0);
    }
}
DeleteMessageExampleCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteMessageExampleCommand_Aai20";
DeleteMessageExampleCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




